module.exports = __webpack_public_path__ + "media/images/post-placeholder2-bad0dfb4a3d68db684ad2083641e4034.jpg";